<template>
  <section>
    <div class="column is-one-third is-offset-one-third m-t-100">
      <div class="card ">
        <div class="card-content">
          <b-message v-if="$route.query.redirect" type="is-danger">
            You need to login first.
          </b-message>
          <div class="field">
            <b-field label="Login">
              <b-input v-model="username"></b-input>
            </b-field>
          </div>
          <div class="field">
            <b-field label="Password">
              <b-input
                type="password"
                v-model="password"
                password-reveal
              ></b-input>
            </b-field>
          </div>
          <button
            @click.prevent="doLogin"
            class="button is-success is-outlined "
          >Log In</button>
          <br>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import loginService from '../services/loginService'
  import displayHelper from '../helpers/display-helper'
  import { metro } from '../main'

  export default {
    name: 'login-form',
    data() {
      return {
        username: '',
        password: ''
      }
    },
    methods: {
      doLogin() {
        loginService.validateLogin(this.username, this.password)
          .then((res) => {
            this.$store.commit('SET_IS_LOGGED_IN', true)
            this.$store.commit('SET_LOGIN', this.login)
            this.$store.commit('SET_API_KEY', res.data.authToken.token)
            this.$store.commit('SET_CONFIG', res.data.config)
            this.$store.commit('SET_TENANT', res.data.tenant)
            metro.$emit('api_key_updated', res.data.authToken.token)
            this.$router.push({name: 'MainScreen'})
          })
          .catch((error) => {
            if (error.response && error.response.status === 403) {
              displayHelper.displayError(this, 'Invalid Credentials')
            } else {
              displayHelper.displayError(this, 'Sorry we are unable to serve your request - please contact support')
            }
          })
      },
      goTo() {
        this.$router.push({name: 'MainScreen'})
      },
    }
  }
</script>

<style scoped>

</style>
